import { NgModule } from '@angular/core';
import { ValidDocument1ValidatorDirective } from './valid-document1.directive';
import { ExistsDocument1ValidatorDirective } from './exists-document1.directive';
import { MatchValidatorDirective } from './match.directive';
import { ValidTelephoneValidatorDirective } from './valid-telephone.directive';

@NgModule({
    declarations: [
        ValidDocument1ValidatorDirective,
        ValidTelephoneValidatorDirective,
        ExistsDocument1ValidatorDirective,
        MatchValidatorDirective,
    ],
    imports: [

    ],
    exports: [
        ValidDocument1ValidatorDirective,
        ValidTelephoneValidatorDirective,
        ExistsDocument1ValidatorDirective,
        MatchValidatorDirective,
    ]
})
export class ValidatorsModule {}



// WEBPACK FOOTER //
// /codebuild/output/src2645790472/src/src/app/shared/validators/validators.module.ts